import { Translate } from '@chipinside/translate'

const dateFormatOptions = () =>
  [
    {
      label: `${Translate({ messageKey: ['day', 'month', 'year'], separator: '/' })} (DD/MM/YY)`,
      value: 'DD/MM/YY',
    },
    {
      label: `${Translate({ messageKey: ['day', 'month', 'year'], separator: '/' })} (DD/MM/YYYY)`,
      value: 'DD/MM/YYYY',
    },
    {
      label: `${Translate({ messageKey: ['month', 'day', 'year'], separator: '/' })} (MM/DD/YYYY)`,
      value: 'MM/DD/YYYY',
    },
    {
      label: `${Translate({ messageKey: ['month', 'day', 'year'], separator: '/' })} (MM/DD/YY)`,
      value: 'MM/DD/YY',
    },
    {
      label: `${Translate({ messageKey: ['day', 'month', 'year'], separator: '.' })} (MM.DD.YYYY)`,
      value: 'DD_MM_YYYY_DOT',
    },
    {
      label: `${Translate({ messageKey: ['year', 'month', 'day'], separator: '.' })} (YYYY.MM.DD)`,
      value: 'YYYY_MM_DD_DOT',
    },
    {
      label: `${Translate({ messageKey: ['year', 'month', 'day'], separator: '-' })} (YYYY-MM-DD)`,
      value: 'YYYY-MM-DD',
    },
    {
      label: `${Translate({ messageKey: ['month', 'day', 'year'], separator: '/' })} (M/D/YYYY) ${Translate({ lower: true, messageKey: 'without_leading_zeros' })}`,
      value: 'M/D/YYYY',
    },
    {
      label: `${Translate({ messageKey: ['day', 'month', 'year'], separator: '/' })} (D/M/YYYY) ${Translate({ lower: true, messageKey: 'without_leading_zeros' })}`,
      value: 'D/M/YYYY',
    },
    {
      label: `${Translate({ messageKey: ['day', 'month', 'year'], separator: '/' })} (D/MM/YYYY) ${Translate({ lower: true, messageKey: 'no_leading_zeros_in_day' })}`,
      value: 'D/MM/YYYY',
    },
    {
      label: `${Translate({ messageKey: ['day', 'month', 'year'], separator: '/' })} (DD/M/YYYY) ${Translate({ lower: true, messageKey: 'no_leading_zeros_in_month' })}`,
      value: 'DD/M/YYYY',
    },
    {
      label: `${Translate({ messageKey: ['day', 'month', 'year'], separator: '.' })} (D.M.YYYY) ${Translate({ lower: true, messageKey: 'without_leading_zeros' })}`,
      value: 'D_M_YYYY_DOT',
    },
  ] as const

export type DateFormatOption = ReturnType<typeof dateFormatOptions>[number]['value']

interface IParams {
  defaultValue?: DateFormatOption
}

export const buildDateFormatField = ({ defaultValue }: IParams) => ({
  label: Translate({ messageKey: 'document_date_format' }),
  name: 'date_format',
  options: dateFormatOptions(),
  rules: {
    required: {
      message: Translate({
        messageKey: ['required_field', 'document_date_format'],
        separator: ' - ',
      }),
      value: true,
    },
  },
  type: 'select',
  ...(defaultValue !== undefined && { value: defaultValue }),
})
